import WellBeingPartnerInfo from './WellBeingPartnerInfo'

export default WellBeingPartnerInfo
